import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import SEOContentPageWrapper from 'bundles/unified-seo-content-common/pages/SEOContentPageWrapper';

const ResourceContentPageRoot = loadOnRoute(
  () => import('bundles/unified-seo-content-common/pages/resource/ResourceContentPageRoot')
);
const ResourceCategoryPageRoot = loadOnRoute(
  () => import('bundles/unified-seo-content-common/pages/resource/ResourceCategoryPageRoot')
);

const ResourceMainHubPageRoot = loadOnRoute(
  () => import('bundles/unified-seo-content-common/pages/resource/ResourceMainHubPageRoot')
);

export default (
  <Route path="/" component={SEOContentPageWrapper}>
    <Route path="resources">
      <IndexRoute getComponent={ResourceMainHubPageRoot} />
      <Route path=":slug" getComponent={ResourceContentPageRoot} />
      <Route path="category/:slug" getComponent={ResourceCategoryPageRoot} />
    </Route>
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
